export enum AccommodationOfferOptions {
  NoKitchen = "NoKitchen",
  OwnKitchen = "OwnKitchen",
  SeparateBathroom = "SeparateBathroom",
  Breakfast = "Breakfast",
  CleanOut = "CleanOut",
  SharedKitchen = "SharedKitchen",
  SheetAndTowelsIncluded = "SheetAndTowelsIncluded",
  Parking = "Parking",
  Internet = "Internet",
  Pets = "Pets",
  Gym = "Gym"
}
